const SITE_TITLE = 'NeuroImaging Platform';
const SITE_SLOGAN = '';
// Replaces the Universal Analytics property (UA-3757403-1), shut down in 2023.
const GOOGLE_ANALYTICS_TRACKING_ID = 'G-7PZR3WN7ZQ';
const XOONIPS_ITEMTYPES = ['book', 'paper', 'presentation', 'data', 'tool', 'nimgcenter', 'model', 'url'];

// Vite's BASE_URL always carries a trailing slash ('/' when the app is served
// from the document root). Strip it so it can be concatenated the same way
// CRA's Config.BASE_URL was.
const BASE_URL = import.meta.env.BASE_URL.replace(/\/$/, '');

export type MultiLang = 'en' | 'ja';

const Config = {
    SITE_TITLE,
    SITE_SLOGAN,
    GOOGLE_ANALYTICS_TRACKING_ID,
    XOONIPS_ITEMTYPES,
    BASE_URL,
};

export default Config;
